import { z } from 'zod';

export const CardInfoSchema = z.object({
    type: z.literal('card-info'),
});
export type CardInfo = z.infer<typeof CardInfoSchema>;
